let baseId = 0

/**
 * Returns a globally unique ID
 * (assuming nothing else is created unique IDs in a similar fashion)
 *
 * @param {string=} prefix
 * @return {string|number}
 */
export function createUniqueId(prefix) {
  baseId++

  if (prefix !== undefined) {
    return `${prefix}-${baseId++}`
  }

  return baseId.toString()
}
